import { useState, useCallback, SyntheticEvent } from 'react'

import { isBoolean } from 'Utils'

interface Toggle {
  (newVisible?: boolean | SyntheticEvent): void
}

interface UseToggle {
  (initialVisible?: boolean): [boolean, Toggle, () => void, () => void]
}

const useToggle: UseToggle = (initialValue = false) => {
  const [value, setValue] = useState(initialValue)

  const toggle: Toggle = useCallback(
    (newValue) => setValue((prevValue) => (isBoolean(newValue) ? newValue : !prevValue)),
    [],
  )
  const setTrue = useCallback(() => setValue(true), [])
  const setFalse = useCallback(() => setValue(false), [])

  return [value, toggle, setTrue, setFalse]
}

export default useToggle
